/**
 * Shared Tailwind classes for settings pages — readable in light and dark mode.
 */

export const settingsBackLink =
  'inline-flex items-center gap-1 text-xs text-gray-500 dark:text-[var(--text-sec)] hover:text-gray-800 dark:hover:text-[var(--text-pri)] no-underline';

export const settingsLinkCard =
  'group flex items-start gap-3 rounded-lg border border-gray-200 dark:border-[var(--rule)] bg-white dark:bg-[var(--surface)] p-3.5 transition-all hover:shadow-sm hover:border-primary-400 dark:hover:border-[var(--rule-bright)]';

export const settingsLinkCardIcon =
  'flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-gray-50 dark:bg-[var(--bg-raised)] text-gray-500 dark:text-[var(--text-sec)] transition-colors group-hover:bg-primary-50 dark:group-hover:bg-[var(--active-tint)] group-hover:text-primary-600 dark:group-hover:text-[var(--text-pri)]';

export const settingsLinkCardTitle =
  'text-sm font-semibold leading-snug text-gray-900 dark:text-[var(--text-pri)] group-hover:text-primary-700 dark:group-hover:text-[var(--text-pri)]';

export const settingsLinkCardDesc =
  'mt-0.5 text-xs text-gray-500 dark:text-[var(--text-sec)] leading-snug';

export const settingsGroupHeaderLink =
  'group flex items-center gap-2.5 mb-3 w-fit text-gray-600 dark:text-[var(--text-sec)] hover:text-primary-600 dark:hover:text-[var(--text-pri)]';

export const settingsGroupTitle =
  'text-xs font-mono font-semibold uppercase tracking-widest transition-colors text-gray-400 dark:text-[var(--text-sec)] group-hover:text-primary-500 dark:group-hover:text-[var(--text-pri)]';

export const settingsGroupDesc =
  'text-xs text-gray-400 dark:text-[var(--text-sec)] mb-3 -mt-1';

export const settingsSubsectionTitle =
  'mb-3 text-xs font-mono font-semibold uppercase tracking-widest text-gray-400 dark:text-[var(--text-sec)]';

export const settingsMutedBody =
  'text-sm text-gray-500 dark:text-[var(--text-sec)]';

export const settingsPanel =
  'rounded-xl border border-gray-200 dark:border-[var(--rule)] bg-white dark:bg-[var(--surface)] p-6 text-sm text-gray-600 dark:text-[var(--text-sec)]';
